/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AwsSsmDocs {
    getFixupPrototypeFunction() { return AwsSsmDocs.fixupPrototype; }

    static newInstance(model: Partial<AwsSsmDocs>): AwsSsmDocs {
        let obj = Object.assign(new AwsSsmDocs(), model);
        AwsSsmDocs.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AwsSsmDocs>): AwsSsmDocs {
        if (!model) return null;
        return AwsSsmDocs.newInstance(<AwsSsmDocs> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AwsSsmDocs) {
        if (!obj) return;

        models.AwsSsmDocs.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AwsSsmDocs): boolean {
        Object.setPrototypeOf(obj, AwsSsmDocs.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.created_at === "string") {
            this.created_at = new Date(<string><any>this.created_at);
        }
        if (typeof this.updated_at === "string") {
            this.updated_at = new Date(<string><any>this.updated_at);
        }
        if (typeof this.document_creation_time === "string") {
            this.document_creation_time = new Date(<string><any>this.document_creation_time);
        }
        if (this.permission_details) {
            models.AwsSsmDocsPermissionDetail.fixupPrototype(this.permission_details);
        }
        if (this.tags) {
            for (let val of this.tags) {
                models.KeyValuePair.fixupPrototype(val);
            }
        }
    }

    /**
     * Name of the SSM document
     */
    name: string;

    /**
     * The unique identifier of the master account to which the document is associated.
     */
    master_account_id: string;

    /**
     * ID of the cloud account
     */
    cloud_account_id: string;

    /**
     * Status of the document
     */
    status: models.AwsSsmAutomationDocumentStatus;

    /**
     * The document type
     */
    document_type: string;

    /**
     * The document version.
     */
    latest_version: string;

    /**
     * The Amazon Web Services user that created the document
     */
    owner: string;

    /**
     * The default version
     */
    default_version: string;

    /**
     * DB record created at
     */
    created_at: Date;

    /**
     * Name of the user who created the document
     */
    created_by: string;

    /**
     * DB record last updated at
     */
    updated_at: Date;

    /**
     * Name of the user updated the document
     */
    updated_by: string;

    /**
     * The date the SSM document was created
     */
    document_creation_time: Date;

    /**
     * List of tag key/value pairs
     */
    tags: Array<models.KeyValuePair>;

    /**
     * The classification of a document to help you identify and categorize
     */
    categories: Array<string>;

    /**
     * The value that identifies a documents category
     */
    category_identifiers: Array<string>;

    /**
     * The region of the document
     */
    region: string;

    /**
     * The scope of owner document
     */
    scope: string;

    /**
     * Describes the permissions for a Amazon Web Services Systems Manager document
     */
    permission_details: models.AwsSsmDocsPermissionDetail;

}
